import gql from 'graphql-tag'
import legacyCartFragment from './legacyCartFragment.gql'

export default gql`
  query ($order_id: ID){
    legacy_cart (order_id:$order_id){
      ...legacyCartFragment
    }
  }
  ${legacyCartFragment}
`


// WEBPACK FOOTER //
// ./app/containers/LegacyCartPage/graphql/legacyCartQuery.gql.js